/* Bundle builder — quantity tiers with per-item variant pickers.
   Adds the selected bundle as line-item properties so the quantity and the
   chosen variants travel with the cart item. */
(function () {
  function init(root) {
    if (root.dataset.bundleReady === 'true') return;
    root.dataset.bundleReady = 'true';

    var tiers = root.querySelectorAll('[data-bundle-tier]');
    var itemsWrap = root.querySelector('[data-bundle-items]');
    var items = root.querySelectorAll('[data-bundle-item]');
    if (!tiers.length) return;

    function select(qty) {
      tiers.forEach(function (t) {
        t.classList.toggle('is-active', parseInt(t.dataset.bundleTier, 10) === qty);
      });

      var anyVisible = false;
      items.forEach(function (item) {
        var show = parseInt(item.dataset.bundleItem, 10) <= qty;
        item.hidden = !show;
        if (show) anyVisible = true;
      });
      if (itemsWrap) itemsWrap.hidden = !anyVisible;

      root.dataset.bundleQty = String(qty);

      // Keep the product form's quantity in sync so add-to-cart adds the bundle.
      var form = root.closest('form[action*="/cart/add"]') ||
                 document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var qtyInput = form.querySelector('input[name="quantity"]');
        if (!qtyInput) {
          qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          form.appendChild(qtyInput);
        }
        qtyInput.value = String(qty);
        syncProperties(form, qty);
      }

      root.dispatchEvent(new CustomEvent('bundle:change', {
        bubbles: true,
        detail: { quantity: qty, discount: activeDiscount() }
      }));
    }

    function activeDiscount() {
      var active = root.querySelector('[data-bundle-tier].is-active');
      return active ? parseInt(active.dataset.bundleDiscount, 10) || 0 : 0;
    }

    // Mirror each visible item's selects into hidden line-item properties.
    function syncProperties(form, qty) {
      form.querySelectorAll('[data-bundle-prop]').forEach(function (el) { el.remove(); });
      items.forEach(function (item) {
        var n = parseInt(item.dataset.bundleItem, 10);
        if (n > qty) return;
        item.querySelectorAll('select').forEach(function (sel) {
          var match = sel.name.match(/\[([^\]]+)\]\s*$/);
          var optionName = match ? match[1] : 'Option';
          var input = document.createElement('input');
          input.type = 'hidden';
          input.setAttribute('data-bundle-prop', '');
          input.name = 'properties[Item ' + n + ' — ' + optionName + ']';
          input.value = sel.value;
          form.appendChild(input);
        });
      });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        select(parseInt(t.dataset.bundleTier, 10));
      });
    });

    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches('select')) {
        var form = root.closest('form[action*="/cart/add"]') ||
                   document.querySelector('form[action*="/cart/add"]');
        if (form) syncProperties(form, parseInt(root.dataset.bundleQty || '1', 10));
      }
    });

    select(1);
  }

  function boot() {
    document.querySelectorAll('[data-bundle-builder]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
